import { ElementType } from "react"
import styled, { PolymorphicComponentProps } from "styled-components"
import { DeleteIcon } from "../../icons/Delete"
import { EyeOnIcon } from "../../icons/EyeOn"
import { FileIcon } from "../../icons/File"
import { Typography } from "../../typography"

const AttachmentContainer = styled.div`
  display: flex;
  width: 31rem;
  align-items: center;
`
const FileInfos = styled.div`
  margin-left: 0.5rem;
`

const ActionsContainer = styled.div`
  margin-left: auto;
  display: flex;
`

const Button = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 0.2rem solid transparent;
  &:focus {
    border: ${({ theme }) => `.2rem solid ${theme.colors.grey.$400}`};
  }
`

const StyledName = styled(Typography).attrs(() => ({
  $variant: "body-4-regular",
}))`
  margin: 0;
  padding: 0;
`

const StyledSize = styled(Typography).attrs(() => ({
  $variant: "caption-2",
}))`
  margin: 0;
  padding: 0;
  color: ${({ theme }) => `${theme.colors.grey.$500}`};
`

export type AttachmentProps<
  C extends ElementType,
  D extends ElementType,
  E extends ElementType,
> = PolymorphicComponentProps<
  "web",
  {
    name: string
    size?: string
    canDelete?: boolean
    canView?: boolean
    onDelete?: () => void
    onView?: () => void
    deleteProps?: PolymorphicComponentProps<
      "web",
      {
        ["data-testid"]?: string
      },
      D,
      D
    >
    viewProps?: PolymorphicComponentProps<
      "web",
      {
        ["data-testid"]?: string
      },
      E,
      E
    >
  },
  C,
  C
>

export const DeprecatedAttachment = <
  C extends ElementType = "div",
  D extends ElementType = "button",
  E extends ElementType = "button",
>({
  name,
  size,
  canDelete = true,
  canView = true,
  onDelete,
  onView,
  deleteProps,
  viewProps,
  ...rest
}: AttachmentProps<C, D, E>) => {
  return (
    <AttachmentContainer {...rest}>
      <FileIcon />
      <FileInfos>
        <StyledName>{name}</StyledName>
        <StyledSize>{size}</StyledSize>
      </FileInfos>
      <ActionsContainer>
        {canDelete && (
          <Button onClick={onDelete} {...deleteProps}>
            <DeleteIcon />
          </Button>
        )}
        {canView && (
          <Button onClick={onView} {...viewProps}>
            <EyeOnIcon />
          </Button>
        )}
      </ActionsContainer>
    </AttachmentContainer>
  )
}
